import React, { Component } from "react";
import { Card, CardHeader, CardBody, Box, Spacer, Text, HStack } from '@chakra-ui/react';

import zoomPlugin from 'chartjs-plugin-zoom';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, plugins } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt, faArrowCircleDown, faArrowCircleUp, faCaretUp, faCaretDown } from "@fortawesome/free-solid-svg-icons";

import { randNumber } from '@ngneat/falso';
import { format, parseISO, isMonday } from "date-fns";

import LocalStorageService from "../../../../services/LocalStorageService";
import CoreService from "../../../../services/CoreService";



import ChartOptions from "../EnterpriseTotals/models/ChartOptionsExtension";
import { dotMultiply } from "mathjs";



ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  zoomPlugin
);



// tbd - create a fake chart that shows nothing...
const labels = ['Loading...'];
export const data = {
  labels,
  datasets: [
    {
      label: 'Dataset 1',
      data: labels.map(() => randNumber({ min: 0, max: 0 })),
      backgroundColor: 'rgb(255, 99, 132)',
    }
  ],
};

function toChartData(apiData) {
  const labels = apiData.map((rec) => {
    var dt = parseISO(rec.postDateTime);
    //var dt = DateTime.fromISO(rec.postDateTime);
    return (isMonday(dt) === 1) ? format(dt, 'yyyy LLL dd  hh') :
      format(dt, 'dd hh');


  });

  const dataOk = apiData.map((rec) => {
    return rec.ok;
  });
  const dataReject = apiData.map((rec) => {
    return rec.reject;
  });

  var result = {
    labels: labels, datasets: [
      { label: "Passed", data: dataOk, backgroundColor: 'rgb(75, 192, 192)' },
      { label: "Reject", data: dataReject, backgroundColor: 'rgb(255,99,132' }
    ]
  };
  return result;
}

export default class EnterpriseActivityChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      chartLabels: ["Loading..."],
      chartData: data,
      isLoading: false,
      isCollapsed: false
    };

    this.localStorageService = new LocalStorageService();
    this.coreService = new CoreService();

    this.refreshChartData = this.refreshChartData.bind(this);
    this.toggleCollapse = this.toggleCollapse.bind(this);
    this.toggleHorizontal = this.toggleHorizontal.bind(this);
  }

  async componentDidMount() {
    //if (this.props.searchParamsKey && !this.state.isCollapsed) {
    if (!this.state.isCollapsed) {
      await this.refreshChartData();
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    if ((this.props.searchParamsKey !== prevProps.searchParamsKey) || (this.state.isCollapsed != prevState.isCollapsed)) {
      await this.refreshChartData();
    }
  }

  async refreshChartData() {
    if (this.state.isCollapsed) return; // don't bother!
    this.setState({ isLoading: true });
    try {
      var rawResponse;
      var newChartData;
      /*
      if (this.props.searchParams?.schemaId) {
        var schema = this.localStorageService.getSchema(this.props.currentSchemaId);
        rawResponse = await this.coreService.fetchBatchStatusBySearch(this.props.searchParams, schema?.search, this.props.userSession.gcid, this.props.userSession.token);
        newChartData = toChartData(rawResponse.dataResult.data);
      }
      else {
      */
        rawResponse = await this.coreService.fetchActivityBarChartData(this.props.userSession.gcid, this.props.userSession.token);
        newChartData = toChartData(rawResponse.dataResult);
      //}

      this.setState({
        chartData: newChartData
      });
    }
    finally {
      this.setState({ isLoading: false });
    }
  }

  toggleCollapse() {
    let newIsCollapsed = !this.state.isCollapsed;
    this.setState({
      isCollapsed: newIsCollapsed
    });
  }

  toggleHorizontal() {
    let newIsCollapsed = !this.state.isCollapsed;
    let newCaretState = newIsCollapsed ? "caret-down" : "caret-up";
    this.setState({
      isCollapsed: newIsCollapsed,
      moreCaret: newCaretState,
    });
  }

  render() {
    const loadingIcon = this.state.isLoading ? (
      <FontAwesomeIcon icon={faSyncAlt} color="green" spin />
    ) : (
      ""
    );



    return (
      <Box width="-webkit-fill-available">
        {/* <FontAwesomeIcon icon={(this.state.isCollapsed) ? faArrowCircleDown : faArrowCircleUp} color="white" onClick={() => this.toggleCollapse()} /> */}
        {loadingIcon}

        <Bar
          data={this.state.chartData}
          options={
            ChartOptions.TimeSeriesChartOptions(this.props.title, this.props.showLegend)
          }
          height="50%"

        />
      </Box>
    );
  }
}
